import { createFileRoute } from "@tanstack/react-router";

import { ConnectPage } from "@/connect/ConnectPage";
import { validateConnectSearch } from "@/connect/search";

export const Route = createFileRoute("/conectar/")({
  validateSearch: validateConnectSearch,
  component: ConnectPage,
});
